import { AccountType } from '@/components/Modals/CreateAccount/types';
import { BUSINESS_PLAN_TITLE } from '@/lib/pricing/businessPlans';

import type { BillingMode } from '@/atoms/billing';

export const ACCOUNT_TYPE_TO_PRICING_TITLE: Record<string, string> = {
  [AccountType.Free]: 'free',
  [AccountType.Essentials]: 'essentials',
  [AccountType.Creator]: 'creator',
  [AccountType.Pro]: 'pro',
  [AccountType.Business]: BUSINESS_PLAN_TITLE,
};

/**
 * The `?plan=` query value for the free tier. Free has no paid checkout, so
 * /subscribe redirects it away rather than rendering the dead-end checkout
 * (DEV-6057).
 */
export const FREE_PLAN_NAME = 'free';

/**
 * `?plan=` query values that map to a paid tier the /subscribe checkout can
 * actually start. `premium` is a legacy alias for `creator`; `business` now
 * means the 2026 Business tier rather than the legacy Pro alias it used to.
 * Excludes `free` (see FREE_PLAN_NAME) — used to validate the plan param before
 * the page does any auth or data work.
 */
export const VALID_PAID_PLAN_NAMES: ReadonlySet<string> = new Set([
  'essentials',
  'creator',
  'premium',
  'pro',
  'business',
]);

export interface BillingAddress {
  city: string;
  country: string;
  line1: string;
  line2?: string;
  postal_code: string;
  state: string;
}

export interface CheckoutState {
  billingAddress: BillingAddress | null;
  billingMode: BillingMode;
  isBusiness: boolean;
  taxId: string | null;
  taxIdType: string | null;
}
